import * as React from 'react';
import { green, pink } from '@mui/material/colors';
import FolderIcon from '@mui/icons-material/Folder';
import PageviewIcon from '@mui/icons-material/Pageview';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { Grid, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';

export default function MobileMenu() {
  const theme = useTheme();
  const appMode = useSelector((state) => state.mode.mode);
  
  const menuItems = [
    {
      title: 'Referrals',
      route: '/referrals',
      icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068352/gift_mjan0v.png',
      description: 'Invite Friends'
    },
    {
      title: 'Funding',
      route: '/account-wallet',
      icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068353/wallet_b7ymoh.png',
      description: 'Add Funds'
    },
    {
      title: 'Invest',
      route: '/package/Investment Suite',
      icon: 'https://res.cloudinary.com/dqi4rtyvh/image/upload/v1739919729/profits_atawbu.png',
      description: 'Investment Suite'
    },
    {
      title: 'Portfolio',
      route: '/assets',
      icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068347/wallet_1_vmr3li.png',
      description: 'Asset Overview'
    }
  ];

  return (
    <Box sx={{ px: 1, py: 1.5, mb: 1 }}>
      <Grid container spacing={1}>
        {menuItems.map((item, index) => (
          <Grid item xs={3} sm={4} md={2} key={index}>
            <Box
              component={RouterLink}
              to={item.route}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '6px 0',
                textDecoration: 'none',
                color: 'inherit',
                transition: 'transform 0.2s ease, opacity 0.2s ease',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  opacity: 0.85
                }
              }}
            >
              <Box 
                component="img"
                src={item.icon}
                alt={item.title}
                sx={{ 
                  width: 36, 
                  height: 36,
                  mb: 0.5,
                  borderRadius: 0,
                  objectFit: 'contain'
                }}
              />
              
              <Typography 
                variant="caption" 
                sx={{ 
                  fontWeight: 500,
                  fontSize: '0.7rem',
                  color: appMode === 'dark' ? '#fff' : '#1a1a1a',
                  lineHeight: 1.2,
                  textAlign: 'center'
                }}
              >
                {item.title}
              </Typography>
            </Box>
      </Grid>
        ))}
      </Grid>
        </Box>
  );
}